import React from 'react';
import PropTypes from 'prop-types';

const Attachment = ({ attachment }) => (
  <div className="attachment">
    <a href={attachment.downloadUrl} rel="noopener noreferrer" target="_blank">{attachment.displayName}</a>
    <div className="small text-muted mt-2">Uploaded {attachment.uploadedOn}</div>
  </div>
);

Attachment.propTypes = {
  attachment: PropTypes.shape({
    id: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    uploadedOn: PropTypes.string.isRequired
  })
};

export default Attachment;
